import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { theme } from "shared/assets/theme";
import { ThemeProvider } from "styled-components";
import Routing from "./routes";
import "./locale/i18n";

const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language === "ptBr" ? "pt-BR" : "en";
  }, [i18n.language]);

  return (
    <ThemeProvider theme={theme}>
      <Routing />
    </ThemeProvider>
  );
};

export default App;
